/* unplugin-vue-components disabled */import { render } from "./ResultCopySpeach.vue?vue&type=template&id=7391c29c&scoped=true&ts=true"
import script from "./ResultCopySpeach.vue?vue&type=script&lang=ts"
export * from "./ResultCopySpeach.vue?vue&type=script&lang=ts"

import "./ResultCopySpeach.vue?vue&type=style&index=0&id=7391c29c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7391c29c"]])

export default __exports__